import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initSentry, Sentry } from './lib/sentry';
import './styles/index.css';

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashFallback />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

function CrashFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: '#0E1747',
        color: '#FFFFFF',
        fontFamily: 'Inter, system-ui, sans-serif',
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <div
          style={{
            fontSize: 11,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            opacity: 0.6,
            marginBottom: 12,
          }}
        >
          sadmin error
        </div>
        <h1 style={{ fontSize: 24, fontWeight: 500, margin: 0 }}>Что-то пошло не так</h1>
        <p style={{ marginTop: 16, fontSize: 15, lineHeight: 1.6, opacity: 0.85 }}>
          Ошибка отправлена в Sentry. Перезагрузите страницу.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            marginTop: 24,
            padding: '12px 22px',
            background: '#E85624',
            color: '#FFFFFF',
            border: 0,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          Перезагрузить
        </button>
      </div>
    </div>
  );
}
